import React from "react";
import FrontHeader from "../../shared/FrontHeader/FrontHeader";
import FrontFooter from "../../shared/FrontFooter/FrontFooter";
import illustration from "../../../assets/images/appImages/illustration.png";
import { TeamData } from "./data";


export const CustomBeautyTitle = ({ title }: { title: string }) => {
  return <h2 className="custom-esb-title">{title}</h2>;
};

const TeamCard = ({
  photo,
  name,
  role,
  twitter,
  facebook,
  linkedin,
}: {
  photo?: string;
  name: string;
  role: string;
  twitter?: string;
  facebook?: string;
  linkedin?: string;
}) => {
  return (
    <div className="team-card">
      <span className="photo-wrapper">
        <img loading="lazy" src={photo} alt="photo" />
      </span>
      <span className="name">{name}</span>
      <span className="role">{role}</span>
    </div>
  );
};



function WhoWeAre() {
  return (
    <div className="landing-page-component">
      <FrontHeader />
      <div className="page-content who-we-are-page pb-5 pb-5">
        <h1 className="custom-page-title">Qui sommes-nous ?</h1>
        <div className="who-we-are">
          <div className="container">
            <div className="row">
              <div className="col-md-6 mb-4">
                <div className="illustration-container">
                  <img loading="lazy" src={illustration} alt="image" />
                </div>
              </div>
              <div className="col-md-6 mb-4">
                <CustomBeautyTitle title="Qui sommes nous?" />
                <h3 className="custom-title">
                  AMLYS : Une marque de tradition et d'innovation
                </h3>
                <div className="custom-content">
                  Créée  en 1998, AMLYS est une marque dédiée à la création de mode et d'accessoires de bureau,
                  mettant en valeur les tissus traditionnels, notamment le pagne tissé à la main. Initialement
                  formalisée en 2006 sous forme de Groupement d’Intérêt Économique (GIE).
                  <br />
                  AMLYS a été ebaptisée suite à la pandémie de Covid-19 sous son appellation actuelle  pour
                  redonner vie à un héritage culturel.
                </div>
              </div>
              <div className="col-md-12 mb-4">
                <div className="custom-content">
                  Les pagnes tissés à la main, réalisés par des artisans locaux, ont marqué l'enfance de la fondatrice,
                  bercée par les souvenirs de ses parents et grands-parents qui, sous l'arbre à palabres, confectionnaient
                  ces textiles avec passion.
                </div>
              </div>
              <div className="col-lg-12 mb-4">
                <div className="pb-3 para custom-content">
                  Cet amour du pagne, transmis de mère en fille, est à l’origine de la volonté de valoriser et
                  promouvoir cette richesse culturelle unique. Ainsi, AMLYS propose des créations modernes à partir
                  de ce textile traditionnel : vêtements, écharpes, sacs, pochettes, portefeuilles, porte-documents,
                  sacs pour ordinateurs, sets de bureau et divers accessoires. Aujourd'hui, AMLYS entame une nouvelle
                  aventure, ambitieuse et créative. La marque se distingue par sa diversité, son originalité et sa vision
                  tournée vers l'avenir, avec pour objectif de perpétuer cet héritage tout en développant son rayonnement
                  au-delà des frontières. AMLYS s'engage à offrir des pièces uniques, alliant modernité et tradition, dans
                  l’esprit de préserver et partager les bijoux culturels hérités de nos ancêtres.
                </div>
              </div>
            </div>
          </div>

          <div className="mt-5 our-team gray_sky">
            <div className="container">
              <CustomBeautyTitle title="Team" />
              <h3 className="custom-title">Notre équipe</h3>
              <div className="row pt-4">
                {!!TeamData &&
                  TeamData.map((member, key) => {
                    return (
                      <div className="col-lg-4 col-md-4 mb-4 card-wrapper" key={key}>
                        <TeamCard
                          photo={member.photo}
                          name={member.name}
                          role={member.role}
                        />
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>

        </div>

      </div>
      <div style={{ padding: '5rem 0' }}></div>
      <FrontFooter />
    </div>
  );
}

export default WhoWeAre;
